<form>
  <div class="form-group row mb-2">
    <div class="col-sm-2 col-form-label">Surrenders Remaining</div>
    <div class="col-sm-10">
      <span class="form-text" id="returns">{{
        contract?.returnsRemaining
        }}</span>
    </div>
  </div>
  <div class="notice notice-error" *ngIf="contract.returnsRemaining == 0">
    <div class="notice-body">
      You have no more surrenders remaining. Please contact <a [href]="mailtoLinkSurrender">support&#64;cristie.com</a> to increase your
      surrender count.
    </div>
  </div>
  <div class="form-group row mb-2">
    <div class="col-sm-2 col-form-label">Surrender Token <span class="text-danger">*</span></div>
    <div class="col-sm-10">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Surrender Token</mat-label>
        <input matInput type="text" id="surrender-token-input" [(ngModel)]="surrenderToken" [ngModelOptions]="{standalone: true}" />
        <mat-hint align="start">You can obtain this from the Return License window, found in Licensing Options on your Cristie
          Appliance</mat-hint>
      </mat-form-field>
    </div>
  </div>
  <div class="form-group row mb-2">
    <div class="col-sm-2 col-form-label">Appliance ID <span class="text-danger">*</span></div>
    <div class="col-sm-10">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Appliance ID</mat-label>
        <input matInput type="text" id="appliance-uuid-input" [(ngModel)]="applianceUuid" [ngModelOptions]="{standalone: true}" />
        <mat-hint align="start">Can be found under Tools -> Help -> About on your Cristie Appliance</mat-hint>
      </mat-form-field>
    </div>
  </div>
  <div class="notice" *ngIf="success">
    <div class="notice-body">
      Surrender successful
    </div>
  </div>

  <div class="offline-surrender-actions">
    <button mat-flat-button color="primary" id="offline-surrender-button" (click)="offlineReturn()"
      [disabled]="surrenderDisabled()">
      <mat-spinner *ngIf="surrendering" diameter="20" mode="indeterminate"></mat-spinner>
      {{ surrendering ? 'Surrendering' : 'Surrender' }}
    </button>
  </div>
</form>

<ng-template #surrenderModal>
  <div class="mat-dialog-container">
    <h2 mat-dialog-title id="offline-surrender-dialog-title" class="dialog-title">
      <span class="title-text">Offline Surrender</span>
      <button mat-icon-button type="button" class="close-icon" aria-label="Close" id="offline-surrender-dismiss-button"
        (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <mat-dialog-content>
      <div class="notice notice-error" *ngIf="error">
        <div class="notice-body">
          One or more licenses could not be surrendered.<br>
          {{ error?.description || error?.message || "Please check the surrender token and appliance ID, then try again." }}
        </div>
      </div>
      <div class="notice" *ngIf="success">
        <div class="notice-body">
          Licenses successfully returned
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-raised-button color="primary" type="button" id="offline-surrender-close-button" (click)="closeDialog()">
        Close
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
